import React, { createContext, useContext, useState } from 'react';

interface Context {
  activeId: string | null;
  setActiveId: (id: string | null) => void;
}

export const AccordionGroupContext = createContext<Context | undefined>(
  undefined,
);

interface Props {
  children: React.ReactNode;
}

export function AccordionGroup({ children }: Props) {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <AccordionGroupContext.Provider value={{ activeId, setActiveId }}>
      {children}
    </AccordionGroupContext.Provider>
  );
}

export const useAccordionGroup = () => useContext(AccordionGroupContext);
export default useAccordionGroup;
